import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    dialog: {
        border: 'none !important',
        padding: '1.5rem',
        maxWidth: 500,
        width: '45%',
    },
});
